import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { elementWrapper, errorsWrapper } from './Errors.css';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { textColorsVars } from '@design-system/vars.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type ShowableErrors = {
  title: string;
  messages: Array<string | { names: string[]; msg: string }>;
} | null;
export const Errors = (p: { data: ShowableErrors }) => {
  if (!p.data) return null;
  const scrollToElement = (names: string[]) => {
    const element = names
      .map((n) =>
        n.startsWith('#')
          ? document.getElementById(n.replace('#', ''))
          : document.querySelector(`[name="${n}"]`),
      )
      .find((e) => e !== null);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      (element as HTMLElement).focus();
    }
  };

  return (
    <Row className={errorsWrapper} gap="m">
      {p.data ? (
        <>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            color={textColorsVars['ERROR-100']}
            style={{ marginTop: 2 }}
          />
          <Col>
            <Typography variant="bodyLarge" fontWeight="medium">
              {p.data.title}
            </Typography>
            {p.data.messages.map((e, i) => {
              const isScrollable = typeof e !== 'string';
              const msg = isScrollable ? e.msg : e;
              return (
                <Typography
                  key={msg + i}
                  variant="body"
                  size="medium"
                  fontWeight="medium"
                  className={isScrollable ? elementWrapper : ''}
                  onClick={() => {
                    if (typeof e !== 'string') scrollToElement(e.names);
                  }}
                >
                  {msg}
                </Typography>
              );
            })}
          </Col>
        </>
      ) : null}
    </Row>
  );
};
